import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProfissionaisTipoRepresentacaoService {
  private readonly path = 'profissionais';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all TipoRepresentacao
  list(params?: any): Observable<any> {
    return this.apiService
      .get<{ data: any[] }>(
        `${this.path}/getAllTipoRepresentacao`,
        params
          ? new HttpParams({
              fromObject: params,
            })
          : this.params,
        true
      )
      .pipe(map((response) => response));
  }

  // Get TipoRepresentacao by ID
  public show(id: string): Observable<any> {
    return this.apiService
      .get<{ object: any }>(
        `${this.path}/getTipoRepresentacaoById/${id}`,
        this.params,
        true
      )
      .pipe(map((response) => response.object));
  }

  // Create new TipoRepresentacao
  public store(data: any): Observable<any> {
    return this.apiService
      .post<{ object: any }>(
        `${this.path}/AddTipoRepresentacao`,
        data,
        {},
        true
      )
      .pipe(map((response) => response.object));
  }

  // Update existing TipoRepresentacao
  public update(data: any): Observable<any> {
    return this.apiService
      .put<{ object: any }>(
        `${this.path}/UpdateTipoRepresentacao`,
        data,
        this.params,
        true
      )
      .pipe(map((response) => response.object));
  }

  // Delete existing TipoRepresentacao
  public delete(id: string): Observable<any> {
    return this.apiService.delete(
      `${this.path}/DeleteTipoRepresentacaoById/${id}`,
      this.params,
      true
    );
  }
}
